(function() {
    'use strict';
    
    const modal = document.getElementById('sas-find-store-modal');
    if (!modal) return;
    
    const isStorePage = window.location.pathname.includes(window.SAS_FIND_STORE_PAGE_HANDLE);
    
    // If on the store page, hide button and disable modal
    if (isStorePage) {
      const buttons = document.querySelectorAll('[data-open-modal="sas-find-store-modal"]');
      buttons.forEach(btn => btn.style.display = 'none');
      modal.style.display = 'none';
      return;
    }
    
    // Open modal - content is already loaded in the HTML
    document.addEventListener('click', function(e) {
      const openButton = e.target.closest('[data-open-modal="sas-find-store-modal"]');
      if (openButton) {
        e.preventDefault();
        modal.classList.add('sas-modal--open');
        document.body.style.overflow = 'hidden';
      }
    });
    
    // Close modal
    document.addEventListener('click', function(e) {
      const closeButton = e.target.closest('[data-close-modal="sas-find-store-modal"]');
      if (closeButton || e.target.classList.contains('sas-modal__overlay')) {
        e.preventDefault();
        modal.classList.remove('sas-modal--open');
        document.body.style.overflow = '';
      }
    });
    
    // Close with ESC
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && modal.classList.contains('sas-modal--open')) {
        modal.classList.remove('sas-modal--open');
        document.body.style.overflow = '';
      }
    });
  })();
  